/*******************************************************************
* PAGE        : store
* REMARKS     : Comman Redux Data Store
* CREATED ON  : 06-01-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 22-01-2026
********************************************************************/

import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './rootReducer';

import storageSession from 'redux-persist/lib/storage/session';
import { encryptTransform } from 'redux-persist-transform-encrypt';

// const persistConfig = {
//     key: 'root',
//     storage,
//     whitelist: ['reduxMaster'], // NOW THIS WORKS
// };

const persistConfig = {
    key: 'root',
    storage: storageSession,
    transforms: [
        encryptTransform({ secretKey: "^735topSecret" }),
    ],
};

const persistedReducer = persistReducer(
    persistConfig,
    rootReducer
);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);
